export const Types = {
  CREATE_MESSAGE: 'message/CREATE_MESSAGE',
  SET_RESULTS: 'message/SET_RESULTS',
  NEXT_RESULTS: 'message/NEXT_RESULTS',
  SET_PAGE_INFO: 'message/SET_PAGE_INFO',
  SET_ERROR_QUERY: 'message/SET_ERROR_QUERY',
  SET_ERROR_MUTATION: 'message/SET_ERROR_MUTATION',
  SET_SUCCESS_QUERY: 'message/SET_SUCCESS_QUERY',
  SET_SUCCESS_MUTATION: 'message/SET_SUCCESS_MUTATION',
  LOAD_QUERY: 'message/LOAD_QUERY',
  LOAD_MUTATION: 'message/LOAD_MUTATION',
  FETCH_MESSAGES: 'message/FETCH_MESSAGES',
  RESET_STATE: 'message/RESET_STATE',
  USER_LOGOUT: 'USER_LOGOUT',
};

const initialState = {
  results: [],
  pageInfo: {},
  load_query: false,
  load_mutation: false,
  error_query: {},
  error_mutation: {},
  success_query: {},
  success_mutation: {},
};

export default function message(state = initialState, action) {
  switch (action.type) {
    case Types.SET_RESULTS:
      return { ...state, results: action.results };
    case Types.NEXT_RESULTS:
      return { ...state, results: [...state.results, ...action.results] };
    case Types.SET_PAGE_INFO:
      return { ...state, pageInfo: action.pageInfo };
    case Types.SET_ERROR_QUERY:
      return { ...state, error_query: action.error };
    case Types.SET_ERROR_MUTATION:
      return { ...state, error_mutation: action.error };
    case Types.SET_SUCCESS_QUERY:
      return { ...state, success_query: action.success };
    case Types.SET_SUCCESS_MUTATION:
      return { ...state, success_mutation: action.success };
    case Types.LOAD_QUERY:
      return { ...state, load_query: action.load };
    case Types.LOAD_MUTATION:
      return { ...state, load_mutation: action.load };
    case Types.RESET_STATE:
    case Types.USER_LOGOUT:
      return initialState;
    default:
      return state;
  }
}

export function saveMessage({ data, success, error }) {
  return {
    type: Types.CREATE_MESSAGE,
    data,
    success,
    error,
  };
}

export function fetchMessages({ cursor }) {
  return {
    type: Types.FETCH_MESSAGES,
    cursor,
  };
}

export function resetState() {
  return {
    type: Types.RESET_STATE,
  };
}
